import { render, staticRenderFns } from "./PikadayComponent.vue?vue&type=template&id=2c62d5bb"
import script from "./PikadayComponent.vue?vue&type=script&lang=js"
export * from "./PikadayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c62d5bb')) {
      api.createRecord('2c62d5bb', component.options)
    } else {
      api.reload('2c62d5bb', component.options)
    }
    module.hot.accept("./PikadayComponent.vue?vue&type=template&id=2c62d5bb", function () {
      api.rerender('2c62d5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PikadayComponent.vue"
export default component.exports